import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateNotDeliveredReasonRequest,
} from '../not-delivered-reason.actions'
import { getCreateNotDeliveredReasonState } from '../not-delivered-reason.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-create-not-delivered-reason',
  templateUrl: './create-not-delivered-reason.component.html',
  styleUrls: ['./create-not-delivered-reason.component.css'],
})
export class CreateNotDeliveredReasonComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  private state$: Subscription
  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('create'))

    this.state$ = this.store
      .pipe(select(getCreateNotDeliveredReasonState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'create.data',
      ),
    )
    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'create',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      text: 'required',
    }
    const validator = new Validator(
      {
        text: data.get('text'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateNotDeliveredReasonRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'create'),
      )
    }
  }
}
